<template>
  <v-dialog v-model="show" persistent :max-width="width + 'px'">
    <v-card class="confirm-popup">
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="cancelColor + ' darken-1'" text @click="closeModal">
          {{ cancelText }}
        </v-btn>
        <v-btn :color="okColor + ' darken-1'" text @click="createAndClose">
          {{ okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<!--How USE ?

<confirm-popup :show="object.show"
               :title="object.title"
               :content="object.content"
               :width="object.width"
               :cancelText="object.cancelText"
               :okText="object.okText"
               :data="object.data"
               @close="actionClose"/>

-->

<script>
export default {
  name: 'ConfirmPopup',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'Titre de la Modal',
    },
    content: {
      type: String,
      default: 'Contenu de la modal',
    },
    width: {
      type: Number,
      default: 450,
    },
    cancelText: {
      type: String,
      default: 'Fermer',
    },
    cancelColor: {
      type: String,
      default: 'grey',
    },
    okText: {
      type: String,
      default: 'Confirmer',
    },
    okColor: {
      type: String,
      default: 'green',
    },
    data: Object,
  },
  methods: {
    closeModal() {
      this.$emit('close', {
        confirm: false,
        data: this.data,
      });
    },
    createAndClose() {
      this.$emit('close', {
        confirm: true,
        data: this.data,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.confirm-popup {
  .v-card__title {
    padding: 26px 24px 10px !important;
  }
  .v-card__text {
    padding: 10px 24px 26px !important;
    white-space: pre-line;
  }
}
</style>
